import { env } from 'core/config';

export function getBackendEnv() {
  switch (env.STAGE) {
    case 'prod':
      return 'prod';
    case 'staging':
      return 'stage';
    case 'dev':
      return 'develop';
  }
}

export function getRedirectUrls(awsConfig: {
  oauth: {
    redirectSignIn: string;
    redirectSignOut: string;
  };
}) {
  const urlsIn = awsConfig.oauth.redirectSignIn.split(',');
  const urlsOut = awsConfig.oauth.redirectSignOut.split(',');
  // eslint-disable-next-line no-restricted-globals
  const currentHost = location.protocol + '//' + location.host;
  function isCurrentHost(url: string) {
    return url.includes(currentHost);
  }
  return {
    redirectSignIn: urlsIn.find(function (url) {
      return isCurrentHost(url);
    }),
    redirectSignOut: urlsOut.find(function (url) {
      return isCurrentHost(url);
    })
  };
}

/**
 * Utility function to wait for a specified number of milliseconds
 * @param ms - Number of milliseconds to wait
 * @returns Promise that resolves after the specified time
 */
export const wait = (ms: number): Promise<void> => {
  return new Promise((resolve) => setTimeout(resolve, ms));
};
